import { useState } from "react";
import Hardware from "./Hardware";
import "./SingularityNode.css";

function SingularityNode() {
  const validTabs = ["hardware"];
  const hashTab = window.location.hash.replace("#", "");
  const [tab, setTab] = useState(validTabs.includes(hashTab) ? hashTab : "hardware");

  const switchTab = (t) => { setTab(t); window.location.hash = t; };

  return (
    <div className="singularity-page">
      <div className="singularity-header">
        <h2>Singularity Node</h2>
        <span className="singularity-subtitle">Infrastructure Command Center</span>
      </div>

      <div className="tab-bar">
        <button
          className={`tab ${tab === "hardware" ? "active" : ""}`}
          onClick={() => switchTab("hardware")}
        >
          Hardware
        </button>
      </div>

      {tab === "hardware" && <Hardware />}
    </div>
  );
}

export default SingularityNode;
